import React from 'react';
import ReactApexChart from 'react-apexcharts';
import {Loader} from '../../components';

const BarChart = ({isLoading, analysisData = []}) => {
  const data = (!isLoading && analysisData) || [
    {Successful: 0, Failed: 0, Abandoned: 0, verification_date: '2023-09-30'},
    {Successful: 0, Failed: 0, Abandoned: 0, verification_date: '2023-10-31'},
    {Successful: 0, Failed: 0, Abandoned: 0, verification_date: '2023-11-30'},
  ];

  const categories = data?.map(item => item?.verification_date);
  const successfulData = data?.map(item => item?.Completed);
  const failedData = data?.map(item => item?.Failed);
  const abandonedData = data?.map(item => item?.Abandoned);

  const chartData = {
    options: {
      chart: {
        type: 'bar',
        stacked: false,
        toolbar: {show: false},
      },
      dataLabels: {enabled: false},
      xaxis: {
        categories: categories.length ? categories : ['N/A', 'N/A', 'N/A'],
        labels: {
          rotate: -45,
          trim: false,
          hideOverlappingLabels: false,
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetY: -20,
        offsetX: -30,
        width: 450,
        height: 60,
      },
      colors: ['#87D4DB', '#F15D5F', '#2A5392'],
      markers: {size: 3},
      fill: {opacity: 1},
      grid: {
        xaxis: {lines: {show: true, strokeColor: '#CECED2'}},
        yaxis: {lines: {show: true, strokeColor: '#CECED2'}},
      },
    },
    series: [
      {name: 'Successful', data: successfulData},
      {name: 'Failed', data: failedData},
      {name: 'Abandoned', data: abandonedData},
    ],
  };

  return (
    <div id="chart">
      {isLoading ? (
        <Loader height={33} />
      ) : (
        <ReactApexChart
          className="project_line_chart bg-white rounded-b-xl"
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={350}
        />
      )}
    </div>
  );
};

export default BarChart;
